export class Component {
    constructor(args={}) {
        this.args = args;
    }

    code() {}  // implement in PDFBases/.../components/...js
}
